const STORAGE_KEY = 'signinRedirectTo';

export class SigninRedirect {
  static set(path) {
    localStorage.setItem(STORAGE_KEY, path || '');
  }

  static consume() {
    const path = localStorage.getItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
    return path || null;
  }
}
